import { defineMessages } from 'react-intl';

const scope = 't.component.PortalFooter';

export default defineMessages({
  privacyButton: { id: `${scope}.privacyButton` },
  cookieButton: { id: `${scope}.cookieButton` },
  footerText: { id: `${scope}.footerText` },
})